import React, { useContext } from "react";
import { DateFilterContext } from "../../context";
import { TooltipLabel } from "../../styled";
import { ESTIMATED_LABEL_SYMBOL_WIDTH, TOOLTIP_PADDING_X, SELECTED_TICK_HEIGHT } from "./constants";

export default ({ data, svgHeight, withData }) => {
  const { scrollLeft, axisSize, tickWidth } = useContext(DateFilterContext);

  const paddingX = (ESTIMATED_LABEL_SYMBOL_WIDTH * data.label.length) / 2 + TOOLTIP_PADDING_X;
  const labelPostion = Math.min(
    Math.max(scrollLeft + paddingX, data.x + tickWidth / 2),
    scrollLeft + axisSize.width - paddingX,
  );

  return (
    <TooltipLabel
      transform={`translate(${labelPostion}, 0)`}
      x={0}
      y={withData ? SELECTED_TICK_HEIGHT + 4 : svgHeight - 24 - SELECTED_TICK_HEIGHT}
      textAnchor="middle"
    >
      {data.label}
    </TooltipLabel>
  );
};
